import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PageHero from "../components/PageHero";
import ContactCTA from "../components/ContactCTA";
import ClientsMarquee from "../components/ClientsMarquee";
import { clients, caseStudies, assets } from "../data/mock";
import { Quote, ArrowUpRight, Building2 } from "lucide-react";
import { Link } from "react-router-dom";

export default function ClientsPage() {
  return (
    <div className="relative">
      <Header />
      <PageHero
        eyebrow="Our Clients"
        title="Trusted by the UK's"
        accent="most ambitious teams."
        subtitle="From local councils to national contractors, R&C partners with the organisations that build Britain."
        image={assets.highway}
        crumbs={[{ label: "Clients" }]}
      />

      {/* Marquee section */}
      <ClientsMarquee />

      {/* Full client grid */}
      <section className="py-24 lg:py-28 bg-[#08080a]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="max-w-3xl mb-12 reveal">
            <div className="text-[11px] uppercase tracking-[0.3em] text-amber-accent mb-4">The Full List</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05]">
              {clients.length} <span className="text-amber-accent">organisations</span> we work with.
            </h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
            {clients.map((c, i) => (
              <div
                key={c.name}
                className="reveal flex items-center gap-3 p-4 rounded-lg bg-white/[0.02] border border-white/8 hover:border-[#F5D000]/40 hover:bg-white/[0.04] transition-all"
                style={{ transitionDelay: `${i * 30}ms` }}
              >
                <div className="w-9 h-9 rounded-md bg-[#F5D000]/10 border border-[#F5D000]/25 flex items-center justify-center flex-shrink-0">
                  <Building2 className="w-4 h-4 text-[#F5D000]" />
                </div>
                <span className="font-display text-sm font-medium text-white/85">{c.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Case studies */}
      <section className="py-24 lg:py-32 bg-[#0a0a0c] border-y border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="flex items-end justify-between flex-wrap gap-6 mb-12 reveal">
            <div>
              <div className="text-[11px] uppercase tracking-[0.3em] text-amber-accent mb-4">Case Studies</div>
              <h2 className="font-display text-4xl sm:text-5xl font-bold leading-[1.05]">
                In their <span className="text-amber-accent">words.</span>
              </h2>
            </div>
            <Link to="/projects" className="text-sm font-medium text-white/80 hover:text-white link-shimmer">
              View all projects
            </Link>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {caseStudies.map((cs, i) => (
              <article
                key={cs.project}
                className="reveal relative rounded-2xl overflow-hidden border border-white/8 bg-[#101014] group"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="relative aspect-[16/9] overflow-hidden">
                  <img src={cs.cover} alt={cs.project} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="text-[10px] uppercase tracking-[0.22em] text-[#F5D000] mb-1">{cs.client}</div>
                    <div className="font-display text-lg font-bold text-white">{cs.project}</div>
                  </div>
                </div>
                <div className="p-6">
                  <Quote className="w-7 h-7 text-[#F5D000] mb-3" />
                  <p className="text-white/80 leading-relaxed mb-5">{cs.quote}</p>
                  <div className="text-[11px] uppercase tracking-[0.22em] text-white/55">{cs.person}</div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <ContactCTA />
      <Footer />
    </div>
  );
}
